import { FileWriter } from "@/platform"

class FilePos{

    public fmid:number = -99

    // 数据开始指针
    public startPos:number = 0

    // 数据长度
    public dataLength:number = 0

    constructor(fmid?:number){
        if (fmid !== undefined){
            this.fmid = fmid
        }
    }

    writeProject3bin(writer: FileWriter): void {
        writer.writeInt(this.fmid)
        writer.writeInt(this.startPos)
        writer.writeInt(this.dataLength)
    }

}
export default FilePos